import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheet';
import { Calendar } from '../ui/calendar';

interface ScheduleDayPickerSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selected: Date;
  onDaySelect: (date: Date) => void;
}

export function ScheduleDayPickerSheet({
  open,
  onOpenChange,
  selected,
  onDaySelect,
}: ScheduleDayPickerSheetProps) {
  const { t } = useTranslation();
  const [month, setMonth] = useState(selected);

  // Re-center the calendar on the selected day each time the sheet opens.
  useEffect(() => {
    if (open) setMonth(selected);
  }, [open, selected]);

  function handleDayClick(day: Date | undefined) {
    if (!day) return;
    onDaySelect(day);
    onOpenChange(false);
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="pb-8">
        <SheetHeader>
          <SheetTitle className="sr-only">{t('schedule.pickDay')}</SheetTitle>
        </SheetHeader>
        <div className="flex justify-center pt-4">
          <Calendar
            mode="single"
            selected={selected}
            month={month}
            onMonthChange={setMonth}
            onDayClick={handleDayClick}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
